import Box from '@material-ui/core/Box';
import { orderMgmtTimeoutCase } from '../../../../business/order-mgmt';
import { ProductCard } from './card/ProductCard';
import OrderMgmtCardStyle from 'components/order-management/components/order-mgmt-card/OrderMgmtCard.style';

export function TimeoutProducts({ orderDetailDescription }: Props) {
  const { products, orderId } = orderMgmtTimeoutCase();
  const componentClasses = OrderMgmtCardStyle();

  return (
    <Box overflow='auto' className={componentClasses.container}>
      <Box className={componentClasses.descriptionContainer}>
        {orderDetailDescription}
      </Box>
      {products.map(product => (
        <ProductCard
          key={`c-${product.id}`}
          product={product}
          orderId={orderId}
        />
      ))}
    </Box>
  );
}

interface Props {
  orderDetailDescription: string;
}
